import axios from 'axios'
import { message } from 'antd'

const fetchNearbySubcontractors = (projectId, radius) => async (dispatch, getState) => {
  
  dispatch({ type: 'SCREENS/PLANNER/SET_NEARBY_SUBCONTRACTORS_LOADING', payload: true })
  
  try {
    const teamSlug = window.location.pathname.split('/')[3] || 'vividfinishes'
    
    const response = await axios.get('/api/teams/' + teamSlug + '/planner/map/nearby-subcontractors', {
      params: {
        project_id: projectId,
        radius: radius
      }
    })
    
    dispatch({ 
      type: 'SCREENS/PLANNER/SET_NEARBY_SUBCONTRACTORS', 
      payload: response.data.subcontractors 
    })
    
    dispatch({ type: 'SCREENS/PLANNER/SET_NEARBY_SUBCONTRACTORS_LOADING', payload: false })
    
    return response.data
    
  } catch (error) {
    console.error('Error fetching nearby subcontractors:', error)
    message.error('Failed to fetch nearby subcontractors')
    dispatch({ type: 'SCREENS/PLANNER/SET_NEARBY_SUBCONTRACTORS_LOADING', payload: false })
    dispatch({ type: 'SCREENS/PLANNER/SET_NEARBY_SUBCONTRACTORS', payload: [] })
  }
}

export default fetchNearbySubcontractors
